import { render, staticRenderFns } from "./ShowRecibos.vue?vue&type=template&id=7fd1c0e8&scoped=true&"
import script from "./ShowRecibos.vue?vue&type=script&lang=js&"
export * from "./ShowRecibos.vue?vue&type=script&lang=js&"
import style0 from "./ShowRecibos.vue?vue&type=style&index=0&id=7fd1c0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd1c0e8",
  null
  
)

export default component.exports